/* Se exporta la url de la api que es tomada 
    desde una variable de entorno */
export const API_URL = process.env.REACT_APP_API_URL;